import { render, staticRenderFns } from "./DelegationImgRow.vue?vue&type=template&id=da8a4d04&scoped=true"
import script from "./DelegationImgRow.vue?vue&type=script&lang=js"
export * from "./DelegationImgRow.vue?vue&type=script&lang=js"
import style0 from "./DelegationImgRow.vue?vue&type=style&index=0&id=da8a4d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8a4d04",
  null
  
)

export default component.exports